<template>
  <div>
    <!--S 打印-->
    <el-dialog v-loading="loading" :visible.sync="printInfoBox" class="comDlog printDlg" :before-close="closePrintBox" append-to-body :close-on-click-modal="false">
      <div slot="title" class="dialog-title">打印</div>
      <el-form :model="printForm" label-width="180px">
        <el-form-item label="打印类别">
          <el-select v-model="printForm.printWay"  filterable placeholder="请选择" @change="printWaySel()" clearable>
            <el-option v-for="(item,index) in printWayList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>            
        </el-form-item>
        <el-form-item label="立即下单" v-if="operatePrint != 2 && (printForm.printWay == '1004' || printForm.printWay == '1005' || printForm.printWay == '1006' || printForm.printWay == '1007')">
          <el-switch v-model="printForm.subNow"></el-switch>
        </el-form-item>
        <el-form-item label="打印批次备注">
          <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" maxlength="100" show-word-limit placeholder="请填写订单备注" v-model="printForm.printMemo"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" v-show="operatePrint == 2">
          <el-upload class="upload-demo" :action="url" name="files" :on-success="updSuccess" :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :file-list="fileList">
            <el-button type="primary" plain>点击上传</el-button>
          </el-upload>
          <el-link type="primary" :underline="false" href="https://presale.jhtsoft.com/%E5%BF%AB%E9%80%92%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xls">点击此处下载示例文件</el-link>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closePrintBox(1)">确定</el-button>
        <el-button @click="closePrintBox(0)">取消</el-button>
      </div>
    </el-dialog>
    <!--E 打印-->
  </div>
</template>
<script>
import api from '../../apis/api';
export default {
  name: 'OrderMemo',
  data () {
    return {
      fileList: [],
      printForm:{ 
        printWay:'',//打印类别
        printMemo:'',//打印备注
        subNow: false,//立即下单
      },
      printWayList: [ //打印类别
      ],
      printType:'',//打印类别
      url: api.UPLOADFILE(),
      fileUrl: '',//文件地址
      loading: false,
    }
  },
  props: {
    printInfoBox:{ //订单备注弹窗
      type: Boolean,
      default: false,
    },
    operatePrint:{
      type:Number,
      default:0,
    },
    // printInfoLoading: { // 遮罩是否关闭
    //   type: Boolean,
    //   default: false,
    // }
  },
  watch: {
    // printInfoBox(val) {
    //   if(!val) {
    //     this.loading = false;
    //   }
    // },
    // printInfoLoading(val) {
    //   if(val) {
    //     this.loading = false;
    //   }
    // },
    'printForm.printWay'(val) {
      this.printWayList.some(item => {
        if(item.value == val) {
          this.printForm.printMemo = item.label;
          return true;
        }
      })
    }
  },
  methods: {
    //打印类别选择
    printWaySel(){
      this.printType = this.printForm.printWay
    },
    //关闭备注弹窗
    closePrintBox(val){
      // if(val) {
      //   this.loading = true;
      // }
      this.printType = this.printType ? this.printType : this.printForm.printWay,
      this.$emit('closePrintBox', val, this.printType, this.printForm.printMemo, this.fileUrl, this.printForm.subNow);//子组件给父组件传值
    },
    //删除文件
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileUrl = ''
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${ file.name }？`);
      return new Promise((response,reject) => {
        this.$confirm(`确定移除 ${ file.name }？`, '提示', {
          type: 'warning'
        }).then(() => {
            this.fileList = [];
            this.fileUrl = '';
            return response()
        }).catch(() => {
            return reject()
        });
      })
    },
    updSuccess(res, files, fileList) {
      if (res.flag) {
        this.fileUrl = res.url
      } else {
        this.$message.error(res.message)
      }
    },
    //获取可用的快递列表
    getPrintTypes() {
      api.GET_SHOWPRINT({}).then(res => {
        this.printWayList = res.data.data
        this.printWayList.forEach(item => {
          if(item.bdefault == 1) {
            this.printForm.printWay = item.value
          }
        })
      })
    }
  },
  mounted() {
    this.getPrintTypes()
  },
}
</script>

<style scoped>
/*勾选打印弹窗*/
.printDlg >>> .el-dialog {width:680px;}
.printDlg >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.printDlg >>> .el-form-item__content .el-select {width:100%;}

.printDlg >>> .el-upload-list{display: inline-block; vertical-align: top;}
.printDlg >>> .el-upload-list__item:first-child {margin-top:0;margin-left:10px;line-height:40px;}
.printDlg >>> .el-upload-list__item .el-icon-close {line-height:30px;}

.printDlg >>> [class*="el-icon-"], .printDlg >>> [class^="el-icon-"] {font-size: 20px;}
</style>




// WEBPACK FOOTER //
// src/components/DeliveryFolder/PrintInfo.vue